import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BasePaneComponent } from '@app/_v3/components/base-pane.component';
import { UserServiceFormModule } from '@app/account/teacher-page/user-service-form/user-service-form.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { UserServiceCardFullModule } from '@app/meetings/user-service-card-full/user-service-card-full.module';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { RedPointDirective } from '@core/components/red-points/red-point/red-point.directive';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { HelpersBffService } from '@core/services/bff/helpers.service';
import { IconComponent } from '@shared/icon/icon.component';
import { setRedPoints } from '@store/actions/profile.actions';
import { ERedPointsEvents, IRedPointsEvents } from '@store/models';
import { UserService } from 'lingo2-models';
import { InViewportModule } from 'ng-in-viewport';
import { OnUiButtonModule } from 'onclass-ui';
import { filters, tabs } from './constants';
import { LibraryServiceMiniComponent } from './library-service-mini/library-service-mini.component';
import { IServicesTab } from './models';

@Component({
  selector: 'app-my-library-services',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    RouterModule,
    SpinnersModule,
    LibraryElementsModule,
    OnUiButtonModule,
    ModalModule,
    UserServiceCardFullModule,
    UserServiceFormModule,
    MobileModalModule,
    InViewportModule,
    LibraryServiceMiniComponent,
    RedPointDirective,
    NoContentStubComponent,
    IconComponent,
  ],
  templateUrl: './my-library-services.component.html',
  styleUrls: ['./my-library-services.component.scss', '../../panes/filter-content/filter-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/*
 */
export class MyLibraryServicesComponent extends BasePaneComponent<IServicesTab> {
  protected readonly helpers = inject(HelpersBffService);
  public tabs = tabs;

  /*
   */
  override ngOnInit(): void {
    super.ngOnInit();
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.onSelectTab(this.tabs[0]);
  }

  /*
   */
  protected override setupFilter(tab: IServicesTab): void {
    const filter = filters[tab.code];
    if (filter) {
      this._pane = {
        ...this._pane,
        userServiceFilter: filter,
        loaded: false,
        userServices: [],
      };
    }
  }

  /*
   */
  protected override redPointEvent(tab: IServicesTab): ERedPointsEvents {
    switch (tab.code) {
      case 'published':
        return ERedPointsEvents.my_user_service_published;
      case 'moderation':
        return ERedPointsEvents.my_user_service_moderation;
      default:
        return null;
    }
  }

  /*
   */
  protected override getEntityRoute(entity: UserService): string {
    return this.helpers.userServiceRouteUniversal(entity);
  }

  /*
   */
  protected override createNewEntity(): UserService {
    return new UserService({
      author_id: this._me?.id,
      subject_id: this._profile?.teaching_subjects?.[0]?.subject_id,
    });
  }
}
